// Standard HTML MessageChannel: no assumptions about the host's URL scheme.
// Only the public readiness notification uses '*'; the parent sends the proof
// and transferred port to the exact HTTPS Mango frame origin.
// Parent identity + loadId stop unrelated frames/stale loads from supplying a port.
// The 43-character proof is only structurally checked here: /mcp/session verifies
// it against the one-use handoff server-side. A matching shape alone grants nothing.
// Do not replace this with a growing allowlist of native app URL schemes.
export function connectMcpEmbedChannel(loadId: string): Promise<{port: MessagePort; proof: string}> {
  return new Promise((resolve,reject)=>{
    const timer=setTimeout(()=>{window.removeEventListener('message',receive);reject(new Error('Embed channel unavailable'));},10000);
    const receive=(event:MessageEvent)=>{
      if(event.source!==window.parent||event.data?.type!=='mango-channel-init'||event.data.loadId!==loadId||
         !/^[A-Za-z0-9_-]{43}$/.test(event.data.channelProof||'')||event.ports.length!==1)return;
      clearTimeout(timer);window.removeEventListener('message',receive);
      resolve({port:event.ports[0],proof:event.data.channelProof});
    };
    window.addEventListener('message',receive);
    window.parent.postMessage({type:'mango-channel-ready',loadId},'*');
  });
}
